import { Modal } from "antd";
import React, { useState } from "react";
import GrupoFrasesRequest from "../../GrupoFrasesRequest";
import { ModalStatusDelete } from "../../../../Utils/modalStatus";

export const ModalDelete = ({ visible, onCancel, id, estadoFrase }) => {
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [openModalStatus, setOpenModalStatus] = useState(false);

  const deleteFrase = async () => {
    setConfirmLoading(true);
    try {
      const response = await GrupoFrasesRequest.ExcluirGrupoFrases(id);
      if (response.status === 204) {
        estadoFrase((prevState) => prevState.filter((item) => item.id !== id));
        setConfirmLoading(false);
        onCancel();
        setOpenModalStatus(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Modal
        visible={visible}
        onCancel={onCancel}
        onOk={deleteFrase}
        confirmLoading={confirmLoading}
      >
        <text style={{ fontSize: 16, fontWeight: "500" }}>
          Deseja realmente excluir esse Grupo Frases?
        </text>
      </Modal>

      <ModalStatusDelete
        onCancel={() => setOpenModalStatus(false)}
        visible={openModalStatus}
      />
    </>
  );
};
